// Super users have access to all trial dashboard features
export const SUPER_USER_IDS = [
  // Add super admin employee IDs here
  '72b2cad9-6ae2-11e8-a5bb-0624d341e5a7',
  'f92e4a13-e2e4-11eb-b8ee-06a4b75f82a5',
  '2ed90b19-83ea-11e7-ad52-0624d341e5a7',
  'e1b46c58-7789-11ed-916a-8ae7ea4dcf09',
  'd50d231f-af9d-11e8-8942-0624d341e5a7',
  '7d4e52fa-bb63-11ee-a62b-765219de9afe',
  '10677ba4-f02c-11e5-8dc8-0698d46ebbc3',
  '0f058238-fdd2-11e8-aa2f-06a4b75f82a5',
  '503d29a4-206e-11e9-bbb1-06a4b75f82a5',
  'eeaba3e9-6625-11e7-ad2b-0624d341e5a7',
  '2bc15b08-516e-11eb-a0ff-06a4b75f82a5',
  '56b6ddd3-d58e-11eb-b418-06a4b75f82a5',
  '3e62afa7-af99-11e8-a2e2-06eaa8ca921d',
];

// List of employee IDs allowed to generate transcripts AND create annotations
// (Same users for both features - if you can annotate, you need transcripts)
export const TRANSCRIPT_ANNOTATION_ALLOWED_USERS = [
  '41372b02-4b37-11ef-92d2-b27d4731a526',
  'c9dffb3e-54a9-11ef-bc0a-6ea500109e71',
  '11a98cf0-67f2-11ee-a51e-3a03cc559cd4',
  '5adf05b2-9f01-11ee-a512-fe4d0c5dda31',
  'd4a8d8b0-54b8-11ef-a8bd-6ea500109e71',
  '5de2d50e-9f5b-11ee-a508-fe4d0c5dda31',
  '2acf3b9a-eb9d-11f0-a223-3eca1677cc68',
  '07f21f58-2ed8-11ef-b36d-0e75d76985f8',
  'd17b46ba-1a12-11ed-81ac-3e2b3c58e6a4',
  '3576a504-f72c-11ee-ad7c-2240da72ee64',
  '9d0a5db8-0bc1-11f1-837c-56aace8e6953',
  '1accc9d4-77d6-11ee-8a41-5a1e6535500a',
  '50eddabe-795f-11ee-a215-9e30921c65b4',
  'ad897bf3-6f6e-11eb-a650-06a4b75f82a5',
  '21a312b2-6413-11ee-bc88-2e3f4bbf8975',
  '5249000c-b015-11f0-9db4-9e7889d96701',
];

// List of employee IDs allowed to generate sales pitches
export const SALES_PITCH_ALLOWED_USERS = [
  // Add employee IDs here
  '8a7343b8-52fb-11ea-af87-06a4b75f82a5',
  '8fe5f10c-9abf-11ef-8a54-9ac0fe3532e8',
  'f2e4221a-5b44-11f0-a8f8-86295680e319',
  'bd63b132-46db-11f0-a433-b28604e4b2b4',
  'eae5eed8-63b2-11f0-b92f-02201f6acaf2',
  '780be86e-eb2b-11eb-b946-06a4b75f82a5',
  '82ac28c2-c448-11f0-86c6-0280bb50dfcc',
  '655e2f2c-be1c-11f0-a272-e6361b0e6846',
  '47c38d22-4527-11f0-b655-a2c2efc67cfe',
  '11867dac-d3fb-11ef-ac7b-d656370413e8',
  '43c32780-b135-11eb-aea8-06a4b75f82a5',
  'c64622ea-ee85-11ea-9084-06a4b75f82a5',
  'f4305306-1539-11f0-9eba-fede6b4b6f0d',
  '34a18472-9ccd-11ef-b56d-0ef6f402555e',
  '08f57516-0e1c-11f0-93b3-6aaee43fb877',
  '5568c8ce-795f-11ee-811d-667b7533d00f',
  '2942cb5a-cd91-11ef-a088-969c667a8263',
  'bb05816d-5a1b-11eb-a1e8-06a4b75f82a5',
  '2bc1c744-6fc9-11ec-a001-06a4b75f82a5',
  '32551898-b324-11eb-aedd-06a4b75f82a5',
  'efc09532-b1bf-11ec-8e2a-2aff6302ba84',
  'aafaf334-e9fc-11ef-9484-328ee1cbb0f1',
  'b3176f36-8344-11eb-a8ee-06a4b75f82a5',
  'cde97d50-e3e2-11eb-b8f8-06a4b75f82a5',
  '5ce6c22a-b29d-11ec-8258-b2727d37bd7a',
  '9c32bec6-db38-11f0-9cbb-621e29f02e59',
  'f942c784-e9ce-11ef-a8d2-da181e312988',
  '25f8afe4-fa75-11ef-9f10-f6d2ceb0f058',
  '9c258166-a95c-11ef-bb5f-369c21b41327',
  'd3a50cc8-f13f-11ea-90fc-06a4b75f82a5',
  '180ec068-a914-11ec-bb8f-fa54916e8a54',
  '37289a04-c8d1-11ed-912b-aac6041fca8c',
  '803cc706-c85a-11ec-96e2-a6312afd4e10',
];

// List of employee IDs allowed to view Regular Classes tab (classroom recordings + transcripts)
export const REGULAR_CLASS_ALLOWED_USERS = [];
